import { Message } from "@/types";

import { axios } from "../axios.instance";

export type DeleteMessageRequest = {
  messageId: string;
  deletedType: "everyone" | "me";
};

export type DeleteMessageResponse = Message;

export const deleteMessage = async (body: DeleteMessageRequest): Promise<DeleteMessageResponse> => {
  const { data } = await axios.post(`/chats/messages/${body.messageId}/delete`, { deletedType: body.deletedType });

  return data;
};
